/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useCallback, useRef } from "react";
import "./BinTransferMain.css";
import BinTransfer_Breadcrumbs from "./BinTransfer_BreadCrumbs";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import { useSelector } from "react-redux";
import { fExecuteAPI } from "../../Server/Apis";
import {
  BintransferHead_Set,
  BinTransferData_Set,
  BinTransferList_Set,
} from "./SliceBinTransfer";
import { useDispatch } from "react-redux";

import {
  GetGitterColumns,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CmpTextFieldEnter } from "./../../Component/Common/ToolBox/ToolBox";
import { BinTrnasferSummaryCard } from "./BinTrnasferSummaryCard";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
const statusData = [
  {
    id: "Enter",
    statusName: "Enter",
  },
  {
    id: "Post",
    statusName: "Post",
  },
  {
    id: "Delete",
    statusName: "Delete",
  },
  {
    id: "All",
    statusName: "All",
  },
];

// {
//     "DocTypCode": "TB001",
//     "DocTypName": "BIN TRANSFER",
//     "DocNo": "BT/0000001",
//     "Date": "2022-10-17T00:00:00.000Z",
//     "LocCode": "64",
//     "LocName": "SDC",
//     "ReasonCode": "BNTSR0001",
//     "ReasonName": "BIN TRANSFER",
//     "Narration": "",
//     "Status": "ENTER",
//     "Type": "0"
// },
const otherRow = [];

export default function BinTransferData() {
  const [columns, setcolumns] = useState([
    {
      field: "DocTypCode",
      headerName: "Voc Type",
      width: 100,
      hide: true,
    },
    {
      field: "DocNo",
      headerName: "Doc.No",
      width: 150,
    },
    {
      field: "Date",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "DocTypName",
      headerName: "Party Name",
      width: 300,
    },

    {
      field: "Status",
      headerName: "Status",
      width: 200,
    },
  ]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const BinTransferDataFocusOnLoad = useRef(null);
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxBintransferData = useSelector(
    (state) => state.SliceBinTransfer.value.BinTransferData
  );
  const vRdxBinTransferList = useSelector(
    (state) => state.SliceBinTransfer.value.BinTransferList
  );

  const [sLoading, setLoading] = useState(false);
  const [sbinTransferList, setBinTransferList] = useState(vRdxBinTransferList);
  const [sLocation, SetLocation] = useState(vRdxuserLoc);

  const [binTransferData, setBinTransferData] = useState(vRdxBintransferData);
  // const [sBintransferHead, SetBintransferHead] = useState({
  //     DocTypName: "",
  //     DocType: "",
  //     DocNo: 0,
  //     Date: moment(new Date()).format("DD/MM/YYYY"),
  //     LocCode: "",
  //     Reason: "",
  //     Narration: "",
  //     Type: "",
  //     Status: "Enter",
  //     UserCd: vRdxuserInfo.UserID,
  //     IP: ""
  // });

// modal start
const [showModal, setShowModal] = useState(false);
// modal end

  const GetBinTransferList = async () => {
    setLoading(true);
    var vbinTransferData = {
      loc: binTransferData.loc,
      dateFrom: moment(binTransferData.dateFrom).format("MM/DD/YYYY"),
      dateTo: moment(binTransferData.dateTo).format("MM/DD/YYYY"),
      statusVal: binTransferData.statusVal,
      v_UserCd: vRdxuserInfo?.UserID,
      v_VocNo: binTransferData?.DocNo,
    };

    if (vRdxBintransferData?.loc == "" || vRdxBintransferData?.Status == "") {
      vbinTransferData = {
        loc: vRdxuserLoc[0]?.UID,
        dateFrom: moment(new Date()).format("MM/DD/YYYY"),
        dateTo: moment(new Date()).format("MM/DD/YYYY"),
        statusVal: statusData[0].statusName,
        v_UserCd: vRdxuserInfo?.UserID,
        v_VocNo: binTransferData?.DocNo,
      };
    }
    let FinalObj = fcheck_null_undefine_replace_empty(vbinTransferData);
    console.log(vbinTransferData, vbinTransferData);
    const binTransferList = await fExecuteAPI("BIN_TRANSFER_LIST", FinalObj);
    if (binTransferList?.ResultSet?.length !== 0) {
      setLoading(false);
      dispatch(
        BinTransferList_Set({
          BinTransferList: binTransferList.ResultSet,
        })
      );
      // setBinTransferList(binTransferList.ResultSet);
    } else {
      setLoading(false);
      dispatch(
        BinTransferList_Set({
          BinTransferList: binTransferList.ResultSet,
        })
      );
      // setBinTransferList(binTransferList.ResultSet);
    }
  };

  const onPressLoad = () => {
    dispatch(
      BinTransferData_Set({
        BinTransferData: binTransferData,
      })
    );
    GetBinTransferList();
    setShowModal(false);
  };

  const fBinTransferContainer = (e) => {
    setBinTransferData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fStatus = (e) => {
    setBinTransferData((obj) => ({
      ...obj,
      statusVal: e.target.value,
    }));
  };

  const OnpressNew = () => {
    dispatch(
      BintransferHead_Set({
        BintransferHead: {
          DocTypName: "",
          DocType: "",
          DocNo: 0,
          Date: new Date(),
          LocCode: vRdxuserLoc[0].UID,
          Reason: "",
          Narration: "",
          Type: "Between Bin",
          Status: "ENTER",
          UserCd: vRdxuserInfo.UserID,
          IP: vRdxuserInfo.IP,
        },
      })
    );
    navigate("/BinTrnasferForm");
  };

  const fBintransferHeadObj = (item) => {
    console.log(item.row, {
      DocTypName: item.row.DocTypName,
      DocType: item.row.DocTypCode,
      DocNo: item.row.DocNo,
      Date: item.row.Date,
      LocCode: item.row.LocCode,
      Reason: item.row.ReasonCode,
      Narration: item.row.Narration,
      Type: item.row.Type,
      Status: item.row.Status,
      UserCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
    });
    dispatch(
      BintransferHead_Set({
        BintransferHead: {
          DocTypName: item.row.DocTypName,
          DocType: item.row.DocTypCode,
          DocNo: item.row.DocNo,
          Date: item.row.Date,
          LocCode: item.row.LocCode,
          Reason: item.row.ReasonCode,
          Narration: item.row.Narration,
          Type: item.row.Type,
          Status: item.row.Status,
          UserCd: vRdxuserInfo.UserID,
          IP: vRdxuserInfo.IP,
        },
      })
    );
    navigate("/BinTrnasferForm");
  };

  useEffect(() => {
    GetBinTransferList();
    document.getElementsByName("loc")[0]?.focus();
  }, []);

  useEffect(() => {
    setBinTransferList(vRdxBinTransferList);
  }, [vRdxBinTransferList]);

  useEffect(() => {
    if (vRdxBintransferData.loc == "") {
      dispatch(
        BinTransferData_Set({
          BinTransferData: {
            loc: vRdxuserLoc[0]?.UID,
            dateFrom: new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ),
            dateTo: new Date(),
            statusVal: statusData[0].statusName,
            DocNo: "",
          },
        })
      );
    }
  }, []);

  useEffect(() => {
    setBinTransferData(vRdxBintransferData);
  }, [vRdxBintransferData]);

  const itemRows = sbinTransferList?.map((obj, i) => ({
    ...obj,
    id: i + 1,
    // Date: moment(obj.Date).format("DD/MM/YYYY"),
  }));
  useEffect(() => {
    BinTransferDataFocusOnLoad.current?.focus();
  }, []);

  useEffect(() => {
    GetGitterColumns(setcolumns, "BIN_TRANSFER_SUMMARY", columns);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex">
        <BinTransfer_Breadcrumbs />
        <Box className="d-flex">
          <CmpButton
            xbtnName="Filter"
            xOnClick={() => {
              setShowModal(true);
            }}
            xVariant="contained"
            xSize="small"
          />
          &nbsp;
          <CmpButton
            xbtnName="New"
            xOnClick={OnpressNew}
            xVariant="contained"
            xSize="small"
          />
        </Box>
      </div>
      <div className="BinTransferContainer">
        {/* <BinTransfer_Breadcrumbs /> */}
        <div className="BinTransferData">
          <div className="gridStyle" style={{display: "none"}}>
            <Grid container spacing={2}>
              <Grid item lg={2} md={4} xs={6}>
                <CmpSelectBox
                  xref={BinTransferDataFocusOnLoad}
                  xLabelText="Location"
                  xValue={
                    binTransferData.loc == ""
                      ? vRdxuserLoc[0]?.UID
                      : binTransferData.loc
                  }
                  xOnChange={(event) => fBinTransferContainer(event)}
                  xName={"loc"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={binTransferData.dateFrom}
                  xOnChange={(newValue) =>
                    setBinTransferData((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }))
                  }
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={binTransferData.dateTo}
                  xOnChange={(newValue) =>
                    setBinTransferData((obj) => ({
                      ...obj,
                      dateTo: newValue.$d,
                    }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6}>
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={
                    binTransferData.statusVal == ""
                      ? statusData[0].statusName
                      : binTransferData.statusVal
                  }
                  xOnChange={(event) => fStatus(event)}
                  xName={"statusVal"}
                  xData={statusData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
                <CmpTextFieldEnter
                  xLabelText={"Doc.No"}
                  xVariant={"outlined"}
                  xValue={binTransferData.DocNo}
                  xOnChange={(event) =>
                    setBinTransferData((obj) => ({
                      ...obj,
                      DocNo: event.target.value,
                    }))
                  }
                  xReadOnly={false}
                  xType={"text"}
                  xName={"DocNo"}
                  xOnKeyUp={(e) => {
                    if (e.key === "Enter") {
                      onPressLoad();
                    }
                  }}
                  xOnEnter={(e) => {
                    if (e.key === "Enter") {
                      onPressLoad();
                    }
                  }}
                  xSmShow={!!vMediaQuery}
                />
              </Grid>
              <Grid
                item
                lg={2}
                md={4}
                xs={12}
                className="bintransfet-data-load-btn"
              >
                <CmpButton xbtnName="Load" xOnClick={onPressLoad} />
              </Grid>
            </Grid>
          </div>
          <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter Modal"
        component={
          <>
            <Grid
              container
              spacing={{ xs: 2, sm: 2, md: 2 }}
              className="align-items-center"
              columns={{ xs: 12, sm: 12, md: 8 }}
            >
              <Grid item lg={2} md={4} xs={12}>
              <CmpSelectBox
                  xref={BinTransferDataFocusOnLoad}
                  xLabelText="Location"
                  xValue={
                    binTransferData.loc == ""
                      ? vRdxuserLoc[0]?.UID
                      : binTransferData.loc
                  }
                  xOnChange={(event) => fBinTransferContainer(event)}
                  xName={"loc"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
              <CmpDatePicker
                  xLabelText={"From"}
                  xValue={binTransferData.dateFrom}
                  xOnChange={(newValue) =>
                    setBinTransferData((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }))
                  }
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
              <CmpDatePicker
                  xLabelText={"To"}
                  xValue={binTransferData.dateTo}
                  xOnChange={(newValue) =>
                    setBinTransferData((obj) => ({
                      ...obj,
                      dateTo: newValue.$d,
                    }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid
                item
                lg={2}
                md={4}
                xs={12}
                className="bintransfer-data-date"
              >
               <CmpSelectBox
                  xLabelText="Status"
                  xValue={
                    binTransferData.statusVal == ""
                      ? statusData[0].statusName
                      : binTransferData.statusVal
                  }
                  xOnChange={(event) => fStatus(event)}
                  xName={"statusVal"}
                  xData={statusData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid
                item
                // lg={2}
                // md={4}
                xs={12}
                className="bintransfer-data-date"
              >
                <CmpTextFieldEnter
                  xLabelText={"Doc.No"}
                  xVariant={"outlined"}
                  xValue={binTransferData.DocNo}
                  xOnChange={(event) =>
                    setBinTransferData((obj) => ({
                      ...obj,
                      DocNo: event.target.value,
                    }))
                  }
                  xReadOnly={false}
                  xType={"text"}
                  xName={"DocNo"}
                  xOnKeyUp={(e) => {
                    if (e.key === "Enter") {
                      onPressLoad();
                    }
                  }}
                  xOnEnter={(e) => {
                    if (e.key === "Enter") {
                      onPressLoad();
                    }
                  }}
                  xSmShow={!!vMediaQuery}
                />
              </Grid>
              <Grid
                item
                // lg={2}
                // md={4}
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={onPressLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />
          {/* <Box
              sx={{ height: vMediaQuery ? "45vh" : "70vh", width: "100%" }}
              className="bin-transfer-data"
            >
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                getRowId={(row) => row.id}
                rows={itemRows}
                columns={columns}
                // pageSize={10}
                // rowsPerPageOptions={[5]}
                hideFooter={itemRows.length < 100}
                experimentalFeatures={{ newEditingApi: false }}
                // onRowClick={(item) => navigate('/BinTrnasferForm/VocNo=' + item.row.DocTypCode, { state: item.row })}
                // onRowClick={(item) => navigate('/BinTrnasferForm', { state: item.row })}
                onRowClick={fBintransferHeadObj}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </Box> */}

          {itemRows?.length > 0 && (
            <Box>
              <Grid
                container
                spacing={{ xs: 0, md: 3 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
              >
                {itemRows?.map((obj, index) => (
                  <Grid item xs={12} sm={12} md={4} key={index}>
                    <BinTrnasferSummaryCard
                      DocNo={obj.DocNo}
                      VocType={obj.DocTypCode}
                      Status={obj.Status}
                      DocTypeName={obj.DocTypName}
                      Date={moment(obj.Date).format("DD/MM/YYYY")}
                      onClick={() => {
                        let e = {
                          row: obj,
                        };
                        fBintransferHeadObj(e);
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* <div className="bin-transfer-data-new-btn">
            <CmpButton
              xbtnName="New"
              xOnClick={OnpressNew}
              xSendIcon={<AddIcon />}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}
